export const environment = {
  production: true,
  // Persist forms to the Forms microservice via the gateway in production.
  formsBackendEnabled: true
};
